const shortCode = [
  {
    id: 1,
    name: "Nom Parent",
    code: "[parent]",
  },
  {
    id: 2,
    name: "Login Parent",
    code: "[login]",
  },
  {
    id: 3,
    name: "Mot de passe parent",
    code: "[pass_parent]",
  },
  {
    id: 4,
    name: "Lien Application",
    code: "[lien_app]",
  },
  {
    id: 5,
    name: "Lien Inscription",
    code: "[lien_inscription]",
  },
  {
    id: 6,
    name: "Nom Enseignant",
    code: "[enseignant]",
  },
  {
    id: 7,
    name: "Classe",
    code: "[classe]",
  },
  {
    id: 8,
    name: "Nom Elève",
    code: "[nom_eleve]",
  },
  {
    id: 9,
    name: "Lien Android",
    code: "[lien_android]",
  },
  {
    id: 10,
    name: "Lien Appel",
    code: "[lien_appel]",
  },
];

export default shortCode;
